/**
 * Boost AI Search & Discovery - Analytics Tracking
 * Version: 1.2.0
 */

// IMMEDIATE EXECUTION - This must run when file loads
(function() {
  try {
    if (window.location.search.indexOf('boost_debug') !== -1 || (typeof localStorage !== 'undefined' && localStorage.getItem('boostAnalyticsDebug') === '1')) {
      console.log('%c[BOOST ANALYTICS] Script loaded at: ' + new Date().toISOString(), 'background: #4CAF50; color: white; padding: 5px; font-size: 14px;');
    }
  } catch(e) {}
})();

// Main analytics module
(function() {
  'use strict';

  // Enable debug via URL param or localStorage
  try {
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('boost_debug') === '1' || localStorage.getItem('boostAnalyticsDebug') === '1') {
      window.BoostAnalyticsDebug = true;
    }
  } catch(e) {}

  try {
    if (window.BoostAnalyticsDebug) {
      console.log('[Boost Analytics] Starting initialization...');
    }
  } catch(e) {}

  // Configuration
  var CONFIG = {
    ENDPOINT: 'https://lambda.mybcapps.com/e',
    SESSION_KEY: 'boostSdSessionId',
    REQUEST_IDS_KEY: 'boostPFSRequestIds',
    /** Max age for a stored request ID (ms). Only use rid from requests within this window. */
    RID_MAX_AGE_MS: 5 * 60 * 1000,
    DEBUG: false // Set true via ?boost_debug=1 or localStorage 'boostAnalyticsDebug'
  };

  // User Actions
  var USER_ACTION = {
    VIEW_PRODUCT: 'view_product',
    QUICK_VIEW: 'quick_view',
    ADD_TO_CART: 'add_to_cart',
    BUY_NOW: 'buy_now'
  };

  // Action Types
  var ACTION = {
    FILTER: 'filter',
    SEARCH: 'search',
    SUGGEST: 'suggest',
    RECOMMEND: 'recommend'
  };

  // Simple logger - respects CONFIG.DEBUG or ?boost_debug=1 / localStorage
  function log() {
    var debugOn = CONFIG.DEBUG || window.BoostAnalyticsDebug;
    if (debugOn) {
      try {
        var args = Array.prototype.slice.call(arguments);
        args.unshift('[Boost Analytics]');
        console.log.apply(console, args);
      } catch(e) {}
    }
  }

  // Generate UUID
  function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0;
      var v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  // Get or create session ID
  function getSessionId() {
    try {
      var sid = localStorage.getItem(CONFIG.SESSION_KEY);
      if (!sid) {
        sid = generateUUID();
        localStorage.setItem(CONFIG.SESSION_KEY, sid);
      }
      return sid;
    } catch(e) {
      return generateUUID();
    }
  }

  // Get stored request IDs
  function getRequestIds() {
    try {
      var stored = localStorage.getItem(CONFIG.REQUEST_IDS_KEY);
      return stored ? JSON.parse(stored) : {};
    } catch(e) {
      return {};
    }
  }

  // Set request ID
  function setRequestId(actionType, rid) {
    if (!rid) return;
    try {
      var requestIds = getRequestIds();
      requestIds[actionType] = { rid: rid, timestamp: Date.now() };
      localStorage.setItem(CONFIG.REQUEST_IDS_KEY, JSON.stringify(requestIds));
      log('Request ID stored:', actionType, rid);
    } catch(e) {
      log('Error storing request ID:', e);
    }
  }

  // Get request ID for action type (returns null if stored value is older than RID_MAX_AGE_MS)
  function getRequestId(actionType) {
    var requestIds = getRequestIds();
    var entry = requestIds[actionType];
    if (!entry || !entry.rid) return null;
    if (entry.timestamp && (Date.now() - entry.timestamp > CONFIG.RID_MAX_AGE_MS)) return null;
    return entry.rid;
  }

  /**
   * Get the most recently stored (actionType, rid) that is still within RID_MAX_AGE_MS.
   * This ensures we send the action and requestId that match the request that produced
   * the current results (Filter, Search, or Suggestion).
   * @returns {{ actionType: string, rid: string } | null}
   */
  function getMostRecentRequestContext() {
    try {
      var requestIds = getRequestIds();
      var now = Date.now();
      var best = null;
      var bestTime = 0;
      for (var actionKey in requestIds) {
        if (!Object.prototype.hasOwnProperty.call(requestIds, actionKey)) continue;
        var entry = requestIds[actionKey];
        if (!entry || !entry.rid || !entry.timestamp) continue;
        if (now - entry.timestamp > CONFIG.RID_MAX_AGE_MS) continue;
        if (entry.timestamp > bestTime) {
          bestTime = entry.timestamp;
          best = { actionType: actionKey, rid: entry.rid };
        }
      }
      return best;
    } catch (e) {
      return null;
    }
  }

  // Get current page type
  function getPageType() {
    var path = window.location.pathname;
    if (path.indexOf('/collections/') !== -1) return 'collection_page';
    if (path.indexOf('/search') !== -1) return 'search_page';
    if (path.indexOf('/products/') !== -1) return 'product_page';
    if (path.indexOf('/cart') !== -1) return 'cart_page';
    if (path === '/' || path === '') return 'home_page';
    return 'other_page';
  }

  // Get action type based on page
  function getActionType() {
    var pageType = getPageType();
    if (pageType === 'search_page') return ACTION.SEARCH;
    if (pageType === 'collection_page') return ACTION.FILTER;
    return ACTION.FILTER;
  }

  // Get search query
  function getSearchQuery() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get('q') || '';
    } catch(e) {
      return '';
    }
  }

  // Get customer ID
  function getCustomerId() {
    try {
      if (window.__st && window.__st.cid) return String(window.__st.cid);
      var meta = document.querySelector('meta[name="customer-id"]');
      if (meta && meta.content) return meta.content;
    } catch(e) {}
    return null;
  }

  // Get cart token
  var cartToken = '';
  function refreshCartToken(callback) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cartToken = cart.item_count > 0 ? cart.token : '';
        log('Cart token:', cartToken ? 'received' : 'empty');
        if (callback) callback(cartToken);
      })
      .catch(function(e) {
        log('Cart fetch error:', e);
        if (callback) callback('');
      });
  }

  // Send event to analytics endpoint
  function sendEvent(data) {
    // Always log all values to console + Network-tab equivalent
    try {
      var requestHeaders = { 'Content-Type': 'application/json' };
      var requestPayload = JSON.stringify(data);
      console.group('%c[Boost Analytics] REQUEST (Console + Network values)', 'background: #2196F3; color: white; padding: 6px 10px; font-size: 12px;');
      console.log('%c--- Request ---', 'font-weight: bold;');
      console.log('Request URL:', CONFIG.ENDPOINT);
      console.log('Request Method: POST');
      console.log('Request Headers:', requestHeaders);
      console.log('\n%c--- Payload (every value) ---', 'font-weight: bold;');
      Object.keys(data).sort().forEach(function(k) {
        console.log('  ' + k + ': ', data[k]);
      });
      console.log('\n%c--- Full JSON (request body) ---', 'font-weight: bold;');
      console.log(JSON.stringify(data, null, 2));
      console.log('\n%c--- Table view ---', 'font-weight: bold;');
      console.table(data);
      console.groupEnd();
    } catch(e) {}

    log('=== SENDING EVENT ===');
    log('User Action:', data.u);
    log('Product ID:', data.pid);
    log('Action Type:', data.a);
    log('Full Data:', JSON.stringify(data, null, 2));

    fetch(CONFIG.ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      keepalive: true
    })
    .then(function(response) {
      return response.text().then(function(text) {
        var body = {};
        try {
          body = text ? JSON.parse(text) : {};
        } catch(parseErr) {
          body = { raw: text };
        }
        // Always log full network response (every value) to console
        try {
          var headersObj = {};
          try {
            if (response.headers && response.headers.forEach) {
              response.headers.forEach(function(v, k) { headersObj[k] = v; });
            }
          } catch(h) {}
          console.group('%c[Boost Analytics] RESPONSE (Network tab values)', 'background: #4CAF50; color: white; padding: 6px 10px; font-size: 12px;');
          console.log('%c--- Response ---', 'font-weight: bold;');
          console.log('Response URL:', CONFIG.ENDPOINT);
          console.log('Status:', response.status, response.statusText);
          console.log('Status OK:', response.ok);
          // console.log('\n%c--- Response Headers (every value) ---', 'font-weight: bold;');
          // console.log(headersObj);
          if (Object.keys(headersObj).length) console.table(headersObj);
          // console.log('\n%c--- Response Body (parsed, every value) ---', 'font-weight: bold;');
          // console.log(body);
          if (body && typeof body === 'object' && !Array.isArray(body)) {
            Object.keys(body).forEach(function(k) {
              // console.log('  ' + k + ': ', body[k]);
            });
            if (Object.keys(body).length) console.table(body);
          }
          // console.log('\n%c--- Response Body (raw) ---', 'font-weight: bold;');
          // console.log(text);
          if (body.error) {
            console.warn('%cServer Error:', 'color: #f44336; font-weight: bold;', body.error || '(empty)');
          }
          console.groupEnd();
        } catch(logErr) {}
        if (response.ok && body.error) {
          console.warn('[Boost Analytics] Server returned error:', body.error || '(empty)');
        }
        log('Event sent! Status:', response.status, body.error ? 'Server error: ' + (body.error || 'empty') : '');
      });
    })
    .catch(function(error) {
      try {
        console.group('%c[Boost Analytics] Network Error', 'background: #f44336; color: white; padding: 4px 8px;');
        console.error('Error:', error);
        console.log('URL:', CONFIG.ENDPOINT);
        console.log('Payload was:', data);
        console.groupEnd();
      } catch(logErr) {}
      log('Event send error:', error);
    });
  }

  // Track an event
  function trackEvent(userAction, productId, variantId, options) {
    options = options || {};
    
    // Use (action, rid) from the most recent API request when available, so they update
    // dynamically per user behavior (Filter, Search, or Suggestion). Fall back to page-based
    // action and stored rid for that action only when no recent request context exists.
    var context = getMostRecentRequestContext();
    var actionType;
    var rid;
    if (context) {
      actionType = options.actionType != null ? options.actionType : context.actionType;
      rid = options.rid != null ? options.rid : context.rid;
    } else {
      actionType = options.actionType || getActionType();
      rid = options.rid || getRequestId(actionType);
    }

    // Always log every input and context value to console
    try {
      var qs = options.query || getSearchQuery();
      var pg = getPageType();
      var cid = getCustomerId();
      console.group('%c[Boost Analytics] TRACK EVENT (every value)', 'background: #9C27B0; color: white; padding: 6px 10px; font-size: 12px;');
      console.log('%c--- Input ---', 'font-weight: bold;');
      console.log('userAction (u):', userAction);
      console.log('productId (pid):', productId);
      console.log('variantId (vid):', variantId);
      console.log('options:', options);
      console.log('\n%c--- Context (all values) ---', 'font-weight: bold;');
      console.log('actionType (a):', actionType);
      console.log('rid (request id):', rid);
      console.log('pageType (pg):', pg);
      console.log('searchQuery (qs):', qs);
      console.log('sessionId (sid):', getSessionId());
      console.log('customerId (cid):', cid);
      console.log('cartToken (ct):', cartToken);
      console.log('referrer (r):', document.referrer || '');
      console.log('tid (tenant):', (typeof Shopify !== 'undefined' && Shopify.shop) ? Shopify.shop : window.location.hostname);
      console.log('storedRequestIds:', getRequestIds());
      console.table({
        'userAction (u)': userAction,
        'productId (pid)': String(productId),
        'variantId (vid)': String(variantId),
        'actionType (a)': actionType,
        'rid': rid,
        'pageType (pg)': pg,
        'searchQuery (qs)': qs,
        'sessionId': getSessionId()
      });
      console.groupEnd();
    } catch(e) {}
    
    log('=== TRACKING EVENT ===');
    log('Action:', userAction);
    log('Product:', productId);
    log('Variant:', variantId);

    var data = {
      tid: (typeof Shopify !== 'undefined' && Shopify.shop) ? Shopify.shop : window.location.hostname,
      eid: generateUUID(),
      sid: getSessionId(),
      t: new Date().toISOString(),
      u: userAction,
      a: actionType,
      pg: getPageType(),
      r: document.referrer || ''
    };

    if (rid) data.rid = rid;
    // Only send numeric product/variant IDs - Boost API rejects handles
    if (productId && /^\d+$/.test(String(productId))) data.pid = String(productId);
    if (variantId && /^\d+$/.test(String(variantId))) data.vid = String(variantId);
    
    var query = options.query || getSearchQuery();
    if (query) data.qs = query;
    
    var customerId = getCustomerId();
    if (customerId) data.cid = customerId;

    // For add to cart/buy now, get cart token first
    if (userAction === USER_ACTION.ADD_TO_CART || userAction === USER_ACTION.BUY_NOW) {
      refreshCartToken(function(token) {
        data.ct = token;
        sendEvent(data);
      });
    } else {
      if (cartToken) data.ct = cartToken;
      sendEvent(data);
    }
  }

  // Find product ID from element - Boost API expects numeric Shopify product ID only
  function findProductId(element) {
    if (!element) return null;
    
    // Check element attributes for numeric product ID
    var id = element.getAttribute('data-id') || 
             element.getAttribute('data-product-id') ||
             element.getAttribute('data-productid') ||
             element.getAttribute('data-product');
    if (id && /^\d+$/.test(String(id))) return id;

    // Check parent elements
    var parent = element;
    var maxDepth = 10;
    while (parent && maxDepth > 0) {
      id = parent.getAttribute('data-id') || 
           parent.getAttribute('data-product-id') ||
           parent.getAttribute('data-productid') ||
           parent.getAttribute('data-product');
      if (id && /^\d+$/.test(String(id))) return id;
      parent = parent.parentElement;
      maxDepth--;
    }

    // Check for hidden product ID (on product pages)
    var hidden = document.querySelector('#hiddenProductId[data-product-id]');
    if (hidden) {
      id = hidden.getAttribute('data-product-id');
      if (id && /^\d+$/.test(String(id))) return id;
    }

    return null;
  }

  // Find variant ID from element
  function findVariantId(element) {
    if (!element) return null;
    
    var id = element.getAttribute('data-variant-id') || element.getAttribute('data-id');
    if (id) return id;

    // Check form for variant input
    var form = element.closest('form');
    if (form) {
      var input = form.querySelector('[name="id"]');
      if (input) return input.value;
    }

    return null;
  }

  // Setup click tracking
  function setupClickTracking() {
    log('Setting up click tracking...');

    document.addEventListener('click', function(e) {
      var target = e.target;

      // Check for product link click
      var productLink = target.closest('a[href*="/products/"]');
      if (productLink) {
        var productId = findProductId(productLink);
        if (productId) {
          log('Product click detected! ID:', productId);
          trackEvent(USER_ACTION.VIEW_PRODUCT, productId);
          return;
        }
      }

      // Check for add to cart button
      var addToCartBtn = target.closest(
        '[data-action="add-to-cart"], ' +
        '.SizeSwatch[data-variant-id], ' +
        'button[name="add"], ' +
        '.product-form__submit, ' +
        '.AddToCartButton, ' +
        '.show-size-for-mobile, ' +
        '[class*="add-to-cart"], ' +
        '[class*="addtocart"]'
      );
      
      // Also check button text content
      if (!addToCartBtn && (target.tagName === 'BUTTON' || target.closest('button'))) {
        var btn = target.tagName === 'BUTTON' ? target : target.closest('button');
        var btnText = (btn.textContent || '').toLowerCase();
        if (btnText.indexOf('add to bag') !== -1 || 
            btnText.indexOf('add to cart') !== -1 ||
            btnText.indexOf('add-to-cart') !== -1) {
          addToCartBtn = btn;
        }
      }

      if (addToCartBtn) {
        var productId = findProductId(addToCartBtn);
        var variantId = findVariantId(addToCartBtn);
        if (productId || variantId) {
          log('Add to cart detected! Product:', productId, 'Variant:', variantId);
          trackEvent(USER_ACTION.ADD_TO_CART, productId || variantId, variantId);
          return;
        }
      }

      // Check for buy now button
      var buyNowBtn = target.closest(
        '.shopify-payment-button button, ' +
        '.shopify-payment-button__button, ' +
        '[data-action="buy-now"], ' +
        '.BuyNowButton'
      );

      if (buyNowBtn) {
        var productId = findProductId(buyNowBtn);
        var variantId = findVariantId(buyNowBtn);
        if (variantId) {
          log('Buy now detected! Product:', productId, 'Variant:', variantId);
          trackEvent(USER_ACTION.BUY_NOW, productId || variantId, variantId);
          return;
        }
      }
    }, true);

    log('Click tracking setup complete!');
  }

  // Setup form tracking
  function setupFormTracking() {
    log('Setting up form tracking...');

    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;

      log('Add to cart form submitted!');

      var variantInput = form.querySelector('[name="id"]');
      var variantId = variantInput ? variantInput.value : null;
      var productId = findProductId(form);

      if (variantId) {
        log('Form submit - Product:', productId, 'Variant:', variantId);
        trackEvent(USER_ACTION.ADD_TO_CART, productId || variantId, variantId);
      }
    }, true);

    log('Form tracking setup complete!');
  }

  // Debug helper - logs every value (Console + Network equivalent)
  function debug() {
    var tid = (typeof Shopify !== 'undefined' && Shopify.shop) ? Shopify.shop : window.location.hostname;
    var recentContext = getMostRecentRequestContext();
    var allValues = {
      endpoint: CONFIG.ENDPOINT,
      tid: tid,
      pg: getPageType(),
      a: getActionType(),
      a_fromContext: recentContext ? recentContext.actionType : null,
      rid_fromContext: recentContext ? recentContext.rid : null,
      sid: getSessionId(),
      rid: getRequestIds(),
      qs: getSearchQuery(),
      ct: cartToken,
      cid: getCustomerId(),
      r: document.referrer || ''
    };
    var elements = {
      '[data-id]': document.querySelectorAll('[data-id]').length,
      '[data-product-id]': document.querySelectorAll('[data-product-id]').length,
      '.Grid__Cell': document.querySelectorAll('.Grid__Cell').length,
      '.ProductItem': document.querySelectorAll('.ProductItem').length,
      'a[href*="/products/"]': document.querySelectorAll('a[href*="/products/"]').length
    };
    console.group('%c=== BOOST ANALYTICS DEBUG (every value) ===', 'background: #E91E63; color: white; padding: 10px; font-size: 16px;');
    console.log('%c--- Context (all values) ---', 'font-weight: bold;');
    Object.keys(allValues).forEach(function(k) { console.log('  ' + k + ':', allValues[k]); });
    console.table(allValues);
    console.log('\n%c--- Product Elements ---', 'font-weight: bold;');
    console.table(elements);
    console.log('\n%c--- Test: BoostAnalytics.testEvent() | BoostAnalytics.track("view_product","123456789") ---', 'font-weight: bold;');
    console.groupEnd();
  }

  // Test event - use numeric product ID so it appears in payload
  function testEvent() {
    log('Sending test event...');
    var testProductId = document.querySelector('[data-product-id]') 
      ? document.querySelector('[data-product-id]').getAttribute('data-product-id') 
      : '123456789';
    trackEvent(USER_ACTION.VIEW_PRODUCT, testProductId, null, { actionType: ACTION.FILTER });
    return 'Test event sent! Check Console for all values, Network tab for POST to lambda.mybcapps.com/e';
  }

  // Initialize
  function init() {
    try {
      if (window.BoostAnalyticsDebug) {
        console.log('%c[BOOST ANALYTICS] Initializing...', 'background: #2196F3; color: white; padding: 5px;');
      }
      
      // Get session ID
      var sid = getSessionId();
      log('Session ID:', sid);

      // Get cart token
      refreshCartToken();

      // Setup tracking
      setupClickTracking();
      setupFormTracking();

      if (window.BoostAnalyticsDebug) {
        console.log('%c[BOOST ANALYTICS] Ready! ✓', 'background: #4CAF50; color: white; padding: 5px; font-size: 14px;');
        console.log('Page:', getPageType(), '| Action:', getActionType());
        console.log('Run BoostAnalytics.debug() | BoostAnalytics.testEvent()');
      }
      // Always dump initial context values on load (every value)
      try {
        console.groupCollapsed('%c[Boost Analytics] Init values (expand to see all)', 'background: #607D8B; color: white; padding: 4px 8px;');
        console.log('sid:', getSessionId());
        console.log('pg:', getPageType());
        console.log('a:', getActionType());
        console.log('tid:', (typeof Shopify !== 'undefined' && Shopify.shop) ? Shopify.shop : window.location.hostname);
        console.log('rid:', getRequestIds());
        console.log('qs:', getSearchQuery());
        console.log('endpoint:', CONFIG.ENDPOINT);
        console.groupEnd();
      } catch(e) {}

      // Auto-fire test event on page load
      testEvent();

    } catch(error) {
      console.error('[Boost Analytics] Init error:', error);
    }
  }

  // Expose globally
  window.BoostAnalytics = {
    init: init,
    debug: debug,
    testEvent: testEvent,
    track: trackEvent,
    setRequestId: setRequestId,
    getRequestId: getRequestId,
    USER_ACTION: USER_ACTION,
    ACTION: ACTION
  };

  // Auto-initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM already loaded, init immediately
    init();
  }

})();
